import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function NavimumbaiAirportToLonavalaCabs() {



    const cardData = {





keyword: "Navi Mumbai Airport to Lonavala Cabs",

headingDescription: "Shreesha Tours & Travels provides reliable and comfortable Navi Mumbai Airport to Lonavala Cab Service for airport transfers, family vacations, weekend getaways, corporate travel, business meetings, sightseeing tours, one-way taxi booking, and round-trip journeys. We offer chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, and premium vehicles to ensure a smooth and relaxing journey from Navi Mumbai Airport to Lonavala. With experienced drivers, flight tracking, timely airport pickups, transparent pricing, clean and well-maintained vehicles, doorstep service, flexible booking options, and 24/7 customer support, we make every trip safe and hassle-free. Whether you are planning a holiday, honeymoon, family outing, or corporate retreat, Shreesha Tours & Travels delivers dependable airport cab services with complete comfort and convenience.",

topPlaces: [
  {
    title: "Tiger Point Lonavala",
    description: "Tiger Point is one of Lonavala's most famous viewpoints, offering breathtaking valley views, cool weather, and spectacular sunrise and sunset experiences."
  },
  {
    title: "Bhushi Dam",
    description: "Bhushi Dam is a popular monsoon attraction known for cascading water, scenic surroundings, and a lively atmosphere, making it a favorite destination for families and tourists."
  },
  {
    title: "Karla Caves",
    description: "Karla Caves are ancient Buddhist rock-cut caves famous for their impressive architecture, historic chaitya hall, and spiritual significance."
  },
  {
    title: "Lohagad Fort",
    description: "Lohagad Fort is a historic hill fort popular among trekkers and history enthusiasts, offering panoramic views of the Sahyadri mountains."
  },
  {
    title: "Rajmachi Fort",
    description: "Rajmachi Fort is a renowned trekking destination surrounded by lush greenery, waterfalls, and scenic landscapes, ideal for adventure lovers."
  },
  {
    title: "Pawna Lake",
    description: "Pawna Lake is a peaceful destination near Lonavala known for lakeside camping, boating, photography, and beautiful sunset views."
  },
  {
    title: "Lion's Point",
    description: "Lion's Point is a popular viewpoint offering stunning mountain scenery, misty valleys, and one of the best sunset experiences in Lonavala."
  },
  {
    title: "Della Adventure Park",
    description: "Della Adventure Park is a premier adventure destination featuring thrilling rides, outdoor activities, luxury accommodation, and entertainment for all age groups."
  },
  {
    title: "Kune Waterfalls",
    description: "Kune Waterfalls is one of Maharashtra's tallest waterfalls, surrounded by lush forests and picturesque landscapes, making it a favorite photography spot."
  },
  {
    title: "Ryewood Park",
    description: "Ryewood Park is a peaceful garden in the heart of Lonavala, known for its greenery, walking paths, children's play area, and relaxing atmosphere."
  }
],


 "services": [
    {
      "name": "Navi Mumbai to Lonavala Cab",
      "description": "Book Navi Mumbai to Lonavala Cab for comfortable, safe, and affordable travel with experienced chauffeurs and well-maintained AC vehicles. Choose from Sedan, Hyundai Aura, Swift Dzire, Ertiga, Innova, Innova Crysta, SUV, Kia Carens, and luxury cabs for weekend trips, family vacations, corporate travel, sightseeing, and one-way or round-trip journeys."
    },
    {
      "name": "Navi Mumbai to Lonavala Cab Fare",
      "description": "Get affordable Navi Mumbai to Lonavala Cab Fare with transparent pricing, no hidden charges, and multiple vehicle options. Enjoy reliable chauffeur-driven cab services with comfortable travel and flexible booking."
    },
    {
      "name": "Navi Mumbai Airport to Lonavala Cabs",
      "description": "Reserve Navi Mumbai Airport to Lonavala Cabs for direct airport pickup with professional chauffeurs, flight tracking, luggage assistance, and comfortable AC vehicles for a hassle-free journey."
    },
    {
      "name": "Navi Mumbai Airport to Lonavala Cab",
      "description": "Book Navi Mumbai Airport to Lonavala Cab for convenient airport transfers with punctual pickups, experienced drivers, and premium vehicles for individuals, families, and business travelers."
    },
    {
      "name": "Navi Mumbai Airport to Lonavala Taxi",
      "description": "Choose Navi Mumbai Airport to Lonavala Taxi for reliable airport transportation with clean AC vehicles, courteous chauffeurs, and affordable fares available throughout the day."
    },
    {
      "name": "Cab from Navi Mumbai Airport to Lonavala",
      "description": "Hire Cab from Navi Mumbai Airport to Lonavala for seamless airport pickup and direct drop with professional drivers, spacious vehicles, and comfortable travel to any destination in Lonavala."
    },
    {
      "name": "Taxi from Navi Mumbai Airport to Lonavala",
      "description": "Book Taxi from Navi Mumbai Airport to Lonavala for dependable airport transfers with verified chauffeurs, well-maintained taxis, and timely pickup services."
    },
    {
      "name": "Book Cab Navi Mumbai Airport to Lonavala",
      "description": "Book Cab Navi Mumbai Airport to Lonavala online with instant confirmation, multiple vehicle choices, transparent pricing, and reliable airport transfer services."
    },
    {
      "name": "Online Cab Booking Navi Mumbai Airport to Lonavala",
      "description": "Choose Online Cab Booking Navi Mumbai Airport to Lonavala for secure reservations, quick confirmation, professional drivers, and convenient airport transportation available 24x7."
    },
    {
      "name": "Best Cab Navi Mumbai Airport to Lonavala",
      "description": "Reserve the Best Cab Navi Mumbai Airport to Lonavala for premium travel with clean vehicles, experienced chauffeurs, punctual airport pickups, and exceptional customer service."
    },
    {
      "name": "Cheapest Cab Navi Mumbai Airport to Lonavala",
      "description": "Book the Cheapest Cab Navi Mumbai Airport to Lonavala with affordable pricing, reliable drivers, AC vehicles, and quality airport transfer services without compromising comfort."
    },
    {
      "name": "Reliable Taxi Navi Mumbai Airport to Lonavala",
      "description": "Choose Reliable Taxi Navi Mumbai Airport to Lonavala for safe airport transportation with professional chauffeurs, sanitized vehicles, flight monitoring, and dependable travel."
    },
    {
      "name": "One Way Cab Navi Mumbai Airport to Lonavala",
      "description": "Reserve One Way Cab Navi Mumbai Airport to Lonavala for economical drop taxi services without return charges. Enjoy flexible pickup timings and comfortable intercity travel."
    },
    {
      "name": "Round Trip Cab Navi Mumbai Airport to Lonavala",
      "description": "Book Round Trip Cab Navi Mumbai Airport to Lonavala for sightseeing, family vacations, business visits, and return travel with flexible schedules and experienced chauffeurs."
    },
    {
      "name": "Airport Pickup Cab Navi Mumbai to Lonavala",
      "description": "Hire Airport Pickup Cab Navi Mumbai to Lonavala for timely airport arrivals with luggage assistance, professional drivers, and direct transportation to hotels, resorts, or homes."
    },
    {
      "name": "Innova Cab Navi Mumbai Airport to Lonavala",
      "description": "Book Innova Cab Navi Mumbai Airport to Lonavala for spacious airport transfers with comfortable seating, extra luggage capacity, and smooth travel for families and groups."
    },
    {
      "name": "Innova Crysta Cab Navi Mumbai Airport to Lonavala",
      "description": "Choose Innova Crysta Cab Navi Mumbai Airport to Lonavala for luxury airport transfers featuring premium interiors, spacious seating, professional chauffeurs, and superior ride comfort."
    },
    {
      "name": "Ertiga Cab Navi Mumbai Airport to Lonavala",
      "description": "Reserve Ertiga Cab Navi Mumbai Airport to Lonavala for affordable family airport transportation with comfortable seating, clean AC vehicles, and reliable service."
    },
    {
      "name": "Swift Dzire Cab Navi Mumbai Airport to Lonavala",
      "description": "Book Swift Dzire Cab Navi Mumbai Airport to Lonavala for economical airport transfers with clean sedan cars, experienced chauffeurs, and comfortable travel."
    },
    {
      "name": "Sedan Cab Navi Mumbai Airport to Lonavala",
      "description": "Choose Sedan Cab Navi Mumbai Airport to Lonavala for budget-friendly airport transportation with AC vehicles, professional drivers, and smooth intercity travel."
    },
    {
      "name": "SUV Cab Navi Mumbai Airport to Lonavala",
      "description": "Book SUV Cab Navi Mumbai Airport to Lonavala for spacious airport transfers with premium comfort, ample luggage space, and reliable chauffeur-driven service."
    }
  ],
  "tableData": [
    ["Navi Mumbai to Lonavala Cab", "Navi Mumbai to Lonavala Cab Fare"],
    ["Navi Mumbai Airport to Lonavala Cabs", "Navi Mumbai Airport to Lonavala Cab"],
    ["Navi Mumbai Airport to Lonavala Taxi", "Cab from Navi Mumbai Airport to Lonavala"],
    ["Taxi from Navi Mumbai Airport to Lonavala", "Book Cab Navi Mumbai Airport to Lonavala"],
    ["Online Cab Booking Navi Mumbai Airport to Lonavala", "Best Cab Navi Mumbai Airport to Lonavala"],
    ["Cheapest Cab Navi Mumbai Airport to Lonavala", "Reliable Taxi Navi Mumbai Airport to Lonavala"],
    ["One Way Cab Navi Mumbai Airport to Lonavala", "Round Trip Cab Navi Mumbai Airport to Lonavala"],
    ["Airport Pickup Cab Navi Mumbai to Lonavala", "Innova Cab Navi Mumbai Airport to Lonavala"],
    ["Innova Crysta Cab Navi Mumbai Airport to Lonavala", "Ertiga Cab Navi Mumbai Airport to Lonavala"],
    ["Swift Dzire Cab Navi Mumbai Airport to Lonavala", "Sedan Cab Navi Mumbai Airport to Lonavala"],
    ["SUV Cab Navi Mumbai Airport to Lonavala", ""]
  ],




whychoose: [
  {
    WhyChooseheading: "Scenic Navi Mumbai Airport to Lonavala Cab Service",
    WhyChoosedescription: "Begin your journey to Lonavala directly from Navi Mumbai Airport with Shreesha Travels. Our chauffeur-driven cabs provide a relaxing travel experience for families, couples, tourists, corporate travellers, and weekend vacationers."
  },
  {
    WhyChooseheading: "Direct Airport Transfers Without Travel Hassles",
    WhyChoosedescription: "Avoid waiting for buses or trains after your flight. Our private airport cabs offer direct pickup from Navi Mumbai Airport and comfortable drop-offs at hotels, resorts, villas, homes, and tourist destinations across Lonavala."
  },
  {
    WhyChooseheading: "Wide Choice of Comfortable Vehicles",
    WhyChoosedescription: "Select from Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles based on your group size, luggage, and travel preferences."
  },
  {
    WhyChooseheading: "Perfect for Holidays, Corporate Trips & Weekend Getaways",
    WhyChoosedescription: "Our Navi Mumbai Airport to Lonavala cabs are suitable for family vacations, honeymoon trips, business retreats, resort transfers, sightseeing tours, destination weddings, and leisure travel."
  },
  {
    WhyChooseheading: "One-Way & Round Trip Airport Cab Options",
    WhyChoosedescription: "Book a one-way airport transfer to Lonavala or choose a round-trip package with flexible return timing, sightseeing stops, and personalized travel itineraries."
  },
  {
    WhyChooseheading: "Experienced Chauffeurs for Expressway Travel",
    WhyChoosedescription: "Our professional drivers are experienced on the Mumbai–Pune Expressway and hill routes, ensuring safe driving, punctual service, and a comfortable journey."
  },
  {
    WhyChooseheading: "Clean, Air-Conditioned & Well-Maintained Cars",
    WhyChoosedescription: "Every vehicle is regularly serviced, sanitized, and inspected before every trip to provide passengers with a clean, reliable, and enjoyable airport transfer experience."
  },
  {
    WhyChooseheading: "Book Navi Mumbai Airport to Lonavala Cabs with Shreesha Travels",
    WhyChoosedescription: "Enjoy transparent pricing, quick booking confirmation, courteous chauffeur service, and dependable airport transportation from Navi Mumbai Airport to Lonavala."
  }
]

};

const faqData = [
  {
    question: "Can I pre-book a cab from Navi Mumbai Airport to Lonavala?",
    answer: "Yes, you can reserve your airport cab in advance by sharing your flight details, arrival time, and destination in Lonavala."
  },
  {
    question: "Do you provide direct airport transfers to hotels and resorts in Lonavala?",
    answer: "Yes, we offer doorstep cab service from Navi Mumbai Airport to hotels, resorts, villas, homes, and tourist locations across Lonavala."
  },
  {
    question: "Which vehicles are available for Navi Mumbai Airport to Lonavala travel?",
    answer: "We provide Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    question: "Can I book a one-way cab to Lonavala?",
    answer: "Yes, one-way airport cab bookings are available along with round-trip and customized sightseeing packages."
  },
  {
    question: "Is this cab service suitable for weekend holidays?",
    answer: "Yes, our airport taxi service is ideal for weekend getaways, family vacations, honeymoon trips, and leisure travel to Lonavala."
  },
  {
    question: "Can I visit Khandala or nearby attractions during my journey?",
    answer: "Yes, customized travel plans can include Khandala, Tiger Point, Bhushi Dam, Pawna Lake, and other nearby attractions."
  },
  {
    question: "Are airport cabs available during late-night flight arrivals?",
    answer: "Yes, our Navi Mumbai Airport to Lonavala cab service operates 24x7 according to your scheduled flight timings."
  },
  {
    question: "How is the Navi Mumbai Airport to Lonavala cab fare calculated?",
    answer: "The fare depends on the selected vehicle, travel distance, trip timing, toll charges, parking, and additional travel requirements."
  },
  {
    question: "Can I book a return cab from Lonavala to Navi Mumbai Airport?",
    answer: "Yes, return airport transfers can be arranged with flexible pickup schedules to match your departure flight."
  },
  {
    question: "How can I book Navi Mumbai Airport to Lonavala Cabs with Shreesha Travels?",
    answer: "Simply provide your flight details, travel date, destination, passenger count, and preferred vehicle to receive a customized quotation and instant booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vishal Naik",
    feedback: "Our airport transfer to Lonavala was excellent. The driver arrived on time, the vehicle was comfortable, and the entire journey through the expressway was smooth.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ruchi Mehta",
    feedback: "We booked a cab after our flight to Lonavala, and the service exceeded our expectations. The car was spotless, the chauffeur was professional, and the trip was completely hassle-free.",
    rating: 5
  }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai Airport to Lonavala Cabs",
  "image": "https://www.shreeshatravels.com/assets/images/navi-mumbai-airport-to-lonavala-cabs.webp",
  "description":
    "Book Navi Mumbai Airport to Lonavala Cabs with Shreesha Tours & Travels for safe and comfortable outstation taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for airport transfers, weekend trips, family vacations, sightseeing tours, one-way, round-trip, and long-distance journeys from Navi Mumbai Airport to Lonavala with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/navi-mumbai-airport-to-lonavala-cabs"
  }
};








    return (
        <div>

<Helmet>
  <title>Navi Mumbai Airport to Lonavala Cabs | Airport Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Navi Mumbai Airport to Lonavala Cabs with Shreesha Travels for safe and comfortable taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for airport transfers, one-way trips, round trips, family vacations, sightseeing, and 24x7 outstation cab booking."
  />

  <meta
    name="keywords"
    content="Navi Mumbai to Lonavala Cab, Navi Mumbai to Lonavala Cab Fare, Navi Mumbai Airport to Lonavala Cabs, Navi Mumbai Airport to Lonavala Cab, Navi Mumbai Airport to Lonavala Taxi, Cab from Navi Mumbai Airport to Lonavala, Taxi from Navi Mumbai Airport to Lonavala, One Way Cab Navi Mumbai to Lonavala, Lonavala Tour Cab from Navi Mumbai, Airport Taxi Navi Mumbai to Lonavala"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/88.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default NavimumbaiAirportToLonavalaCabs;